import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getRegistrationStatus } from '../../services/registrationService';
import './PaymentSuccess.css';

const PaymentSuccess = () => {
  const location = useLocation();
  const { registrationNumber: initialRegistrationNumber, orderId } = location.state || {};

  const [registrationNumber, setRegistrationNumber] = useState(initialRegistrationNumber || null);
  const [paymentStatus, setPaymentStatus] = useState(initialRegistrationNumber ? 'paid' : null);
  const [isLoading, setIsLoading] = useState(!initialRegistrationNumber && !!orderId);

  useEffect(() => {
    if (initialRegistrationNumber || !orderId) {
      return;
    }

    let isMounted = true;

    const fetchStatus = async () => {
      try {
        const result = await getRegistrationStatus(orderId);
        if (isMounted) {
          setRegistrationNumber(result?.data?.registration_number || null);
          setPaymentStatus(result?.data?.payment_status || null);
        }
      } catch (error) {
        // If status lookup fails, fall back to the generic confirmation message below.
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    fetchStatus();

    return () => {
      isMounted = false;
    };
  }, [orderId, initialRegistrationNumber]);

  return (
    <div className="theme-page d-flex align-items-center justify-content-center px-3">
      <section className="w-100 d-flex justify-content-center">
        <div className="theme-card payment-success-card w-100 text-center p-4 p-sm-5">
          <div className="payment-success-icon d-flex align-items-center justify-content-center mx-auto mb-4" aria-hidden="true">
            <span>&#10003;</span>
          </div>

          <p className="theme-eyebrow mb-2">Payment Confirmed</p>
          <h1 className="theme-title mb-3">Thank you for your payment</h1>
          <p className="theme-copy payment-success-copy mx-auto mb-4">
            Your registration payment has been received successfully. Our team
            will review your details and contact you with the next steps soon.
          </p>

          <div className="row g-3 mb-4">
            <div className="col-sm-6">
              <div className="theme-mini-card p-3 h-100">
                <span className="theme-meta-label d-block mb-1">Status</span>
                <strong className="d-block text-white">
                  {isLoading ? 'Checking...' : paymentStatus === 'paid' ? 'Successful' : (paymentStatus || 'Successful')}
                </strong>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="theme-mini-card p-3 h-100">
                <span className="theme-meta-label d-block mb-1">Registration Number</span>
                <strong className="d-block text-white">
                  {isLoading ? 'Checking...' : (registrationNumber || 'Pending confirmation')}
                </strong>
              </div>
            </div>
          </div>

          <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center">
            <Link to="/events" className="btn theme-btn theme-btn-primary px-4">
              Back to Events
            </Link>
            <Link to="/contact" className="btn theme-btn theme-btn-outline px-4">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PaymentSuccess;
